<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Insurance Companies",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
    filterInsurance: {
        titlel:"",
        datefrom: "",
        dateto: moment(new Date()).format("YYYY-MM-DD"),
    },
    fitered_array:[],
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Insurance Companies",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Insurance Companies",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "companyName",
          sortable: true,
          label: "NAME",
        },
        {
          key: "companyContact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "companyEmail",
          sortable: true,
          label: "EMAIL",
        },
        {
          key: "companyAddress",
          sortable: true,
          label: "ADDRESS",
        },
        {
          key: "patients",
          sortable: true,
          label: "CLIENTS",
        },
        {
          key: "payments_total",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "payments_paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        }
      ],
      existingCompany: [],
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("insurance", ["InsuranceCompanies", "InsuranceStatus"]),
    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.fitered_array ? this.fitered_array.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.fitered_array ? this.fitered_array.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchCompanies: "insurance/fetchInsuranceCompanies",
 }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    Fillfilter(){
        this.fitered_array = this.InsuranceCompanies;
    },
    // filter_report() {
    //   let startDate = this.localizeDate(this.filterInsurance.datefrom);
    //   let endDate = this.localizeDate(this.filterInsurance.dateto);
    //   let total_inc = 0;
    //   let total_exp = 0;
    //   if (startDate != "" && endDate != "") {
    //     this.filterInsurance.title =
    //       "InsuranceCompanies REPORT FROM <b class='text-primary'>" +
    //       this.filterInsurance.datefrom +
    //       " </b> TO <b class='text-primary'>" +
    //       this.filterInsurance.dateto +
    //       "</b>";
    //     this.fitered_array = this.InsuranceCompanies.filter((ins) => {
    //       return (
    //         this.localizeDate(ins.payment_date) >= startDate &&
    //         this.localizeDate(ins.payment_date) <= endDate
    //       );
    //     });
    //   }else {
    //     this.fitered_array = this.InsuranceCompanies;
    //   }

    //   this.rep_total.inc_total = this.thousandSeprator(total_inc);
    //   this.rep_total.exp_total = this.thousandSeprator(total_exp);
    // },
  },
  created() {
    this.FetchCompanies();
    this.Fillfilter();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
{{InsuranceCompanies.payment_date}}
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 form-group">
                <label>FROM</label>
                <input
                  @change="filter_report()"
                  type="date"
                  v-model="filterInsurance.datefrom"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-4 form-group">
                <label>TO</label>
                <input
                  @change="filter_report()"
                  v-model="filterInsurance.dateto"
                  type="date"
                  class="form-control m-1"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="fitered_array ? fitered_array : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>            
               
              </b-table>
              <center>
                <h3 v-if="!InsuranceCompanies" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
